document.addEventListener('DOMContentLoaded', () => {
  const bodyElement   = document.querySelector('body'),
    headerElement     = document.querySelector('#header'),
    navigationElement = document.querySelector('#navigation'),
    buttonElement     = document.querySelector('#navigation-button'),
    windowElement     = window,
    documentElement   = document;

  let scrollTop = 0;

  if (!headerElement) return;

  buttonElement.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const navigation_visible = navigationElement.getAttribute('aria-hidden') === 'true' ? false : true;

    buttonElement.setAttribute('aria-expanded', !navigation_visible);
    navigationElement.setAttribute('aria-hidden', navigation_visible);
    headerElement.classList.toggle('l-header--navigation-expanded', !navigation_visible);

    const bodyHasScroll = bodyElement.scrollHeight > windowElement.innerHeight;

    if(navigation_visible) {
      bodyElement.classList.remove('no-scroll');
      bodyElement.classList.remove('no-scroll-placeholder');
      bodyElement.style.top = '';
      windowElement.scroll({top: scrollTop});
      navigationElement.setAttribute('tabindex', '-1');
    }
    else {
      scrollTop = windowElement.scrollY;
      bodyElement.classList.add('no-scroll');
      if (bodyHasScroll) {
        bodyElement.classList.add('no-scroll-placeholder');
      }
      bodyElement.style.top = -scrollTop + 'px';
      navigationElement.removeAttribute('tabindex');
    }
  });

  const closeMenu = (event) => {
    buttonElement.dispatchEvent(new Event('click'));
  }

  const clickOutside = (event) => {
    if (navigationElement.getAttribute('aria-hidden') === 'false' && !event.target.closest('#header') && event.target != buttonElement) {
      closeMenu();
    }
  }
  documentElement.addEventListener('click', clickOutside);
  documentElement.addEventListener('focusin', clickOutside);

  navigationElement.setAttribute('aria-hidden', true);
  navigationElement.setAttribute('tabindex', '-1');
});
